import { Config } from '@catalogo/core-configuration';
import { eventData } from '../../../listen';
import { searchImpressions } from '../pageview/helpers';
import { PaginationSearchEvent, PageLoadEvent } from '../../../types/events';
import { PaginationSearchDatalayer } from '../../../types/datalayer/pagination-search';
import { Ecommerce } from '../../../types/datalayer/pageview';
import getDefaultEventPayload from '../default-event';

export const paginationSearchPayload = (events: eventData, config: Config): void => {
  const pageload = events['page:load'][0] as PageLoadEvent;
  const searchEvent: PaginationSearchEvent = events['pagination:search'][0];

  const { limit, productIds = [], offset, productList = [] } = searchEvent.detail.search;
  const ecommerce: Ecommerce = { impressions: searchImpressions(productList) };

  const defaultEvent = getDefaultEventPayload(pageload, config);
  const event: PaginationSearchDatalayer = {
    ...defaultEvent,
    event: 'pagination_search',
    searchProducts: productIds.join(),
    searchLimit: limit,
    searchOffset: offset == null ? 1 : offset,
    ecommerce,
  };

  window.dataLayer = window.dataLayer || [{}];
  window.dataLayer.push(event);
};
